module.exports = __webpack_public_path__ + "../static/img/url-json-icon.a5576d2b.png";